import { makeActionCreator } from '../../../utilities'
import { StateCustomDataConstants } from './nemsisCustomData.constants'

export const setCustomDisplayData = makeActionCreator(
  StateCustomDataConstants.SET_STATE_CUSTOM_DISPLAY_DATA,
  'stateCustomElements'
)
export const setStateCustomElementValue = makeActionCreator(
  StateCustomDataConstants.SET_STATE_CUSTOM_ELEMENT_VALUE,
  'customElementValue',
  'additionalData'
)
export const setStateCustomElementPNNVValue = makeActionCreator(
  StateCustomDataConstants.SET_STATE_CUSTOM_ELEMENT_PNNV_VALUE,
  'customElementPNNVValue',
  'additionalData'
)
export const setMultiInstanceStateCustomElementPNNVValue = makeActionCreator(
  StateCustomDataConstants.SET_STATE_MULTI_INSTANCE_CUSTOM_ELEMENT_PNNV_VALUE,
  'customElementMultiInstancePNNVValue',
  'additionalData'
)
export const setCustomData = makeActionCreator(StateCustomDataConstants.SET_CUSTOM_DATA, 'customData')
export const duplicateGroup = makeActionCreator(
  StateCustomDataConstants.DUPLICATE_GROUP,
  'state',
  'groupId',
  'groupKey'
)
export const updateCustomGroupsFromTimeLine = makeActionCreator(
  StateCustomDataConstants.UPDATE_GROUPS_FROM_TIMELINE,
  'updateAction',
  'deleteMedicationKey'
)
export const deleteCustomElementGroup = makeActionCreator(
  StateCustomDataConstants.DELETE_CUSTOM_ELEMENT_GROUP,
  'state',
  'groupId',
  'groupingSequence',
  'groupKey'
)
export const duplicateCustomElement = makeActionCreator(
  StateCustomDataConstants.DUPLICATE_CUSTOM_ELEMENT,
  'state',
  'groupId',
  'customElementId',
  'groupKey',
  'groupingSequence',
  'key'
)
export const deleteCustomElement = makeActionCreator(
  StateCustomDataConstants.DELETE_CUSTOM_ELEMENT,
  'state',
  'groupId',
  'groupingSequence',
  'groupKey',
  'customElementId',
  'key'
)
export const setPNNVToggle = makeActionCreator(
  StateCustomDataConstants.SET_PNNV_TOGGLE,
  '_pnnvToggle',
  'additionalData'
)
export const saveCustomData = makeActionCreator(StateCustomDataConstants.SAVE_CUSTOM_DATA)
export const resetNemsisCustomData = makeActionCreator(StateCustomDataConstants.RESET_NEMSIS_CUSTOM_DATA)
